import IFixedTerm from "@/module/main/dto/customer/IFixedTerm";

export default class FixedTerm implements IFixedTerm {
    constructor(public employedTo?: string) {}
}
